/**
 * @desc 根据平台id列表加站点列表获取对应订单
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.omsFlow.OrderInfoRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/omsflow/getOrderInfo`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
